module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_6005.8b6f4681.png";